import { Field } from "./field";
import { FieldMap, ValueOf } from "./types";

export abstract class FieldSet<T> {
  private _fields: Field<ValueOf<T>>[] = [];
  private _fieldMap: FieldMap<ValueOf<T>> = {};

  public fieldSetName = "";

  get fieldMap(): FieldMap<ValueOf<T>> {
    return this._fieldMap;
  }

  get fields(): Field<ValueOf<T>>[] {
    return this._fields;
  }

  set fields(fields: Field<ValueOf<T>>[]) {
    this._fields = fields;
    this._fieldMap = fields.reduce(
      (acc, field) => ({
        ...acc,
        [field.propertyName]: field,
      }),
      {} as FieldMap<ValueOf<T>>
    );
  }

  /**
   * When saving data, certain endpoints will throw if you pass data
   *  they're not expecting for a given model state.
   *
   * So only returning applicable fields will ensure that the data
   *  being sent up is expected
   */
  toFieldValueMap(onlyReturnApplicable?: boolean): T {
    return this.fields
      .filter((f) => (onlyReturnApplicable ? f.applicable : true))
      .reduce(
        (prev, field) => ({
          ...prev,
          [field.propertyName]: field.value,
        }),
        {} as T
      );
  }

  /**
   * Unknown if we'll need this yet?
   * Implemented it while testing formbuilder integration
   */
  updateField(field: Field<T>, value?: ValueOf<T>): void {
    if (this.fieldMap[field.propertyName]) {
      this.fieldMap[field.propertyName].value = value;
    }
  }

  getTestValuesForFieldSet(): FieldMap<ValueOf<T>> {
    return this.fields.reduce(
      (prev, field) => ({
        ...prev,
        [field.propertyName]: field.testValue,
      }),
      {}
    );
  }

  abstract validate({ stringify }: { stringify?: boolean }): void;
}
